const EVENTS = {
  OnboardingStarted: 'session_start',
  PaywallClosed: 'subs_purchase_screen_close',
};

export default EVENTS;
